<style scoped>
</style>

<script>
  import Environment from "./environment.ts";
  export default Environment;
</script>